export const demographicConstants = {
    REQUEST:     'USERS_DEMOGRAPHIC_REQUEST',
    SUCCESS:     'USERS_DEMOGRAPHIC_SUCCESS',
    FAILURE:     'USERS_DEMOGRAPHIC_FAILURE',
}